import { Action, createReducer, on } from "@ngrx/store";
import { RequirementOverrideDetail } from "../../models/requirement-override-detail.model";
import { RequirementOverrideState } from "../state/requirement-override.state";
import * as actions from 'src/app/compliance/store/actions/requirement-override.actions';

const initialState: RequirementOverrideState = {
    details: {} as RequirementOverrideDetail,
    error: undefined,
    isLoading: false
};


const reducer = createReducer(
    initialState,
    on(actions.loadRequirementOverrideDetailsSuccessfully, (state, action) => ({
        ...state,
        details: action.details
    })),
    on(actions.setRequirementOverrideIsLoadingFlag, (state, action) => ({
        ...state,
        isLoading: action.isLoading
    })),
    on(actions.loadRequirementOverrideDetailsFailure, (state, action) => ({
        ...state,
        error: JSON.stringify(action.error)
    })),
);

export function requirementOverrideReducer(state: RequirementOverrideState | undefined, action: Action) {
    return reducer(state, action);
}
